import {useState} 			from 'react';

const useTrigger = (boolean = false) => {
	const [trigger, setTrigger] = useState(boolean);

	const triggerLoader = (boolean = !trigger) => {
		setTrigger(boolean);
	};

	return [
		trigger,
		triggerLoader
	]
};

export default useTrigger;
